import { cn } from '@optools/components/ui/utils';
import { Loader, LoaderCircle } from 'lucide-react';

export interface SpinnerProps {
  className?: string;
  variant?: 'loader-circle' | 'loader';
}

export function Spinner({ className, variant = 'loader-circle' }: SpinnerProps) {
  const Icon = variant === 'loader-circle' ? LoaderCircle : Loader;
  return (
    <Icon
      className={cn(
        'animate-spin',
        {
          ease: variant === 'loader-circle',
          'size-4 duration-300': variant === 'loader',
        },
        className,
      )}
      role="progressbar"
    />
  );
}
